
// Define the base directory path for files

//const BASE_DIR = 'D:/GrantData';  // The base directory path
const BASE_DIR ='/var/www/GrantData'; // The base directory path

// Define the backend API URL

//const API_BASE_URL = 'http://localhost/RGMS'; // Backend API base URL//
const API_BASE_URL = "https://rgms.pdn.ac.lk/api"; // Backend API base URL

export { BASE_DIR, API_BASE_URL };

